import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class MeritorService {

    private API_URL = environment.API_URL;

    constructor(private http: HttpClient) { }

    // public getAllDropDownDetails(qParam: any): Observable<any> {
    //     return this.http.post(`${this.API_URL}/sales/realization/dropdown`, qParam);
    // }

    public getMeritorDropDowns(qParam: any, url): Observable<any> {
        return this.http.post(`${this.API_URL + url}`, qParam);

        const data = {
            
          
           
           
            
            


           
"bill_to_name":["All"],
            "ecc": ["All"],







            "certification": ["All"],
            "main_region": ["All"],
            "part_number": ["All"],
 "product_group":["All"],
"channel":["All"],
        }
        return of(data);
    }

    public getSalesBy(qParam: any, url): Observable<any> {
        return this.http.post(`${this.API_URL + url}`, qParam);
        const data = [
            {
                "current_period_sales": 857136.06,
                "prior_period_sales": 972383.9400000004,
                "region": "AFRICA"
            },
            {
                "current_period_sales": 6767500.5100000035,
                "prior_period_sales": 5203729.259999994,
                "region": "BRAZIL"
            },
            {
                "current_period_sales": 482845.3899999999,
                "prior_period_sales": 680335.5500000004,
                "region": "BUPA"
            },
            {
                "current_period_sales": 0.0,
                "prior_period_sales": 7004.24,
                "region": "CENTRAL AMERICA"
            },
            {
                "current_period_sales": 109047.07999999999,
                "prior_period_sales": 278084.48000000004,
                "region": "CHINA"
            },
            {
                "current_period_sales": 198515.72000000003,
                "prior_period_sales": 672079.7399999996,
                "region": "CIS"
            },
            {
                "current_period_sales": 2.6599346699999955E7,
                "prior_period_sales": 2.8850787200000025E7,
                "region": "EUROPE"
            },
            {
                "current_period_sales": 94423.11000000002,
                "prior_period_sales": 56361.10999999999,
                "region": "INDIA"
            },
            {
                "current_period_sales": 1240051.5599999998,
                "prior_period_sales": 1212989.25,
                "region": "MEXICO"
            },
            {
                "current_period_sales": 3008881.0900000003,
                "prior_period_sales": 2427601.4599999995,
                "region": "MIDDLE EAST"
            },
            {
                "current_period_sales": 1705687.740000001,
                "prior_period_sales": 2072349.3700000008,
                "region": "NESEA"
            },
            {
                "current_period_sales": 4.288095525000001E7,
                "prior_period_sales": 4.170600303999995E7,
                "region": "NORTH AMERICA"
            },
            {
                "current_period_sales": 305838.71,
                "prior_period_sales": 414665.54999999993,
                "region": "NORTH S AMERICA"
            },
            {
                "current_period_sales": 2703427.8899999987,
                "prior_period_sales": 2110748.47,
                "region": "SOUTH PACIFIC"
            },
            {
                "current_period_sales": 453993.7599999999,
                "prior_period_sales": 586538.4700000001,
                "region": "WEST S AMERICA"
            }
        ]
        return of(data);
    }
    public getSalesRealization(qParam: any, url): Observable<any> {
        return this.http.post(`${this.API_URL + url}`, qParam);
        const data = {
            "prior_period_sales": 8.725166112999998E7,
            "price": 7515743.788472619,
            "mix_sales": -2131403.673863614,
            "volume_sales": -5550040.981571272,
            "acquisition_sales": 3666143.2600000002,
            "attrition_sales": -2214927.18,
            "brand_mix_sales": -1468980.1400000001,
            "forex_sales": 339454.3669433231,
            "current_period_sales": 8.740765057E7,
            "ytd_demand_base_period": 7.3855045475282E7,
            "ytd_demand_current_period": 7.137323278027712E7
        }
        return of(data);
    }
    public getAlgorithm(qParam: any, url): Observable<any> {
        return this.http.post(`${this.API_URL + url}`, qParam);
        const data = {
            "x": 0.17878105468684957,
            "y": 5.495212494713398,
            "a": 5384340.114609018,
            "b": 6.171045966204196,
            "h": -5550040.981571272,
            "j": -6.360957384297851,
            "actual_impact": 5384340.114609018,
            "actual_impact_per": 6.171045966204196,
            "target_impact": 1968584,
            "target_impact_per": 2.232213656174119
        }

        return of(data);
    }
    // public getMarginRealization(qParam: any, url): Observable<any> {
    //     return this.http.post(`${this.API_URL + url}`, qParam);
    // }
    // public getDailySales(qParam: any, url): Observable<any> {
    //     return this.http.post(`${this.API_URL + url}`, qParam);
    //     // return this.http.get(`../../../assets/mock.json`);
    // }
    public getTop5(qParam: any, url): Observable<any> {
        return this.http.post(`${this.API_URL + url}`, qParam);
        const data = [
            {
                "current_period_sales": 7203636.279999998,
                "prior_period_sales": 5524082.4399999995,
                "engine_model": "ISC/ISL"
            },
            {
                "current_period_sales": 9443762.81,
                "prior_period_sales": 8076262.390000002,
                "engine_model": "ISX/QSX"
            },
            {
                "current_period_sales": 2.6949426149999913E7,
                "prior_period_sales": 2.603506769000002E7,
                "engine_model": "ISB/QSB"
            },
            {
                "current_period_sales": 1948282.0799999998,
                "prior_period_sales": 1800685.1399999997,
                "engine_model": "ISM/QSM"
            },
            {
                "current_period_sales": 226530.16,
                "prior_period_sales": 84575.92,
                "engine_model": "S60"
            }
        ]
        return of(data);
    }
    public getSalesBridgeData(params, url): Observable<any> {
        return this.http.post(`${this.API_URL + url}`, params);
    }
    public getSalesBridgePercentage(params, url): Observable<any> {
        return this.http.post(`${this.API_URL + url}`, params);
    }
    public getPPI_diamension(params, url): Observable<any> {
        return this.http.post(`${this.API_URL + url}`, params);
    }
    public getTotalPrice(params, url): Observable<any> {
        return this.http.post(`${this.API_URL + url}`, params);
    }
    public getPurePriceImpact(params, url): Observable<any> {
        return this.http.post(`${this.API_URL + url}`, params);
    }
    public gettable(): Observable<any> {
        return this.http.get(`../../../assets/mock.json`);
    }
    public getCharts(params): Observable<any> {
        return this.http.post(
            `${this.API_URL}/sales/realization/productmix`,
            params
        );
    }
    public getsalesCharts(params, url): Observable<any> {
        return this.http.post(`${this.API_URL + url}`, params);
    }
    public getToporBottom(params, url): Observable<any> {
        return this.http.post(`${this.API_URL + url}`, params);
    }

    public getPurePriceAdjustments(params, url): Observable<any> {
        return this.http.post(`${this.API_URL + url}`, params);
    }

    public searchMeritorPartsDropdown(params, searchValue): Observable<any> {
        return this.http.post(
            `${this.API_URL}/nrp/meritor/search/dropdown?search=${searchValue}`,
            params
        );
    }

    public getPartsDropdown(qParam: any, page, size): Observable<any> {
        return this.http.post(
            `${this.API_URL}/nrp/EBU/searchPage/dropdown?page=${page}&size=${size}`,
            qParam
        );
    }
}